import { render, staticRenderFns } from "./email-invoice.vue?vue&type=template&id=1485db26&"
import script from "./email-invoice.vue?vue&type=script&lang=js&"
export * from "./email-invoice.vue?vue&type=script&lang=js&"
import style0 from "./email-invoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports